module.exports = __webpack_public_path__ + "static/media/img_arbre.7d0f5e89.jpg";